import React from 'react'
import { Header } from '@/widgets/Header/Header'
import cls from './main.module.scss'
import { GamblingLobby } from '@/widgets/GamblingLobby/GamblingLobby'
import { ProductList } from '@/widgets/ProductList/ProductList'
import { ContactBanner } from '@/widgets/ContactBanner/ContactBanner'
import { AdminServices } from '@/widgets/AdminServices/AdminServices'
import { ContactForm } from '@/widgets/ContactForm/ContactForm'
import { Footer } from '@/widgets/Footer/Footer'
import { MiniPCPresentation } from '@/widgets/MiniPCPresentation/MiniPCPresentation'
import { DisitributionBlock } from '@/widgets/DistributionBlock/DisitributionBlock'
import { GameBlock } from '@/widgets/GamesBlock/GameBlock'

export const Main = () => {
    return (
        <div id='main' className={cls.wrapper}>
            <Header />
            <main  className={cls.Main}>
                <GamblingLobby />
                <MiniPCPresentation />
                <DisitributionBlock />
                <GameBlock />
                <ProductList />
                <ContactBanner />
                <AdminServices />
                <ContactForm />
            </main>
            <Footer />
        </div>
    )
}
